import { CpErrorInternalInterface } from '../../../interfaces/general/error-internal/error-internal-interface';

export class CpErrorInternalModel implements CpErrorInternalInterface {
  httpStatus: number = -1;
  message: string = '';
  resultCode: number = -1;
  resultCodeDetail: string[] = new Array<string>();

  constructor(init?: Partial<CpErrorInternalModel>) {
    Object.assign(this, init);
  }
}
